// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbItems_container__XDd8c"};